import { ViewChild } from '@angular/core';
import { Component, Inject, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CurrencyPipe, DialogBase, PaymentInfo, RentalEventType, T4RentalService } from 't4core';

@Component({
  selector: 't4-RefundDialog',
  templateUrl: 'RefundDialog.html',
})
export class RefundDialog extends DialogBase implements OnInit {

  public payment: PaymentInfo = new PaymentInfo();

  public refundAmount: number = 0;
  public isInvalid: boolean = false;
  public isToHigh: boolean = false;
  public isToLow: boolean = false;

  public showForm: boolean = true;
  public showLoader: boolean = false;
  public showResults: boolean = false;
  public refundFailed: boolean = false;

  public rentalId: number;
  public message: any;

  constructor(public dialogRef: MatDialogRef<RefundDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService, private cPipe: CurrencyPipe) {
    super("RefundDialog");

    if (data.payment) {
      this.payment = data.payment;
    }

    if (data.rentalId) {
      this.rentalId = data.rentalId;
    }
  }

  ngOnInit(): void {

  }

  public async validate() {
    this.isInvalid = isNaN(this.refundAmount);
    if (this.isInvalid) return;

    this.isToHigh = (this.payment.Amount - this.payment.Refunded - this.refundAmount) < 0;
    if (this.isToHigh) return;

    this.isToLow = this.refundAmount < 0;
    if (this.isToLow) return;

    var formattedAmount = this.cPipe.transform(this.refundAmount, "1.2-2");
    if (await this.UI.confirm("turbo.Bookings.RefundDialog.ConfirmRefund", "ConfirmRefund?", "turbo.Bookings.RefundDialog.ConfirmRefundMessage", "Do you want to refund {0} to the customer?", null, [formattedAmount])) {

      this.showLoader = true;
      this.showForm = false;

      this.refundFailed = !await this.rentalService.RefundPayment(this.payment.Id, this.refundAmount);

      this.showLoader = false; 
      this.showResults = true;
    }

    await this.Api.post<any>("RentalService/RentalEvent", null, { rentalId: this.rentalId, type: RentalEventType.Payment, message: this.message });
  }

  public close() {
    this.dialogRef.close();
  }
}
